import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import ExpandMore from '../shared/ExpandMore.styled';
import styles from './styles';

const EirKeepLandlineCollapseTop = ({
  checkMark,
  expanded,
  handleExpandClick,
  numbering,
  text,
  required,
  disableCollapse,
  isNBIJourney,
  fixedLineValidated,
}) => {
  const theme = useTheme();
  useEffect(() => {
    if (!disableCollapse) handleExpandClick();
  }, [disableCollapse]);
  useEffect(() => {
    if (fixedLineValidated) handleExpandClick();
  }, [fixedLineValidated]);
  return (
    <Grid
      container
      spacing={1}
      margin='auto'
      sx={[
        styles(theme).gridCollapseDimension,
        disableCollapse ? styles(theme).disableScheduleMove : '',
      ]}
    >
      <Grid item container xs={9} md={10} sx={styles(theme).gridText}>
        <Grid
          item
          container
          xs={16}
          direction='row'
          justifyContent='flex-start'
          alignItems='stretch'
          columns={16}
        >
          {numbering && (
            <Grid item xs={1} sx={styles(theme).bbServiceHeaderNumberContainer}>
              <Typography
                variant='subtitle2'
                component='p'
                sx={styles(theme).bbServiceHeaderNumber}
              >
                {numbering}
              </Typography>
            </Grid>
          )}
          <Grid item xs={15} sx={styles(theme).bbServiceRequired}>
            <Typography variant='subtitle2' component='p' sx={styles(theme).bbServiceHeaderText}>
              {text}
              <Typography variant='subtitle2' component='p' sx={styles(theme).requiredText}>
                &nbsp;{required}
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        xs={1}
        justify='flex-end'
        sx={{ direction: 'rtl', paddingTop: '0px!important' }}
      >
        {checkMark && <CheckIcon sx={{ color: '#43B02A' }} />}
      </Grid>
      <Grid
        item
        xs={2}
        md={1}
        sx={disableCollapse ? styles(theme).disableScheduleMove : { paddingTop: '0px!important' }}
      >
        <ExpandMore
          expand={expanded}
          onClick={!disableCollapse ? handleExpandClick : undefined}
          aria-expanded={expanded}
          aria-label='show more'
          tabIndex={disableCollapse ? -1 : 0}
          sx={{
            m: '0 auto',
            height: 24,
            width: 24,
            p: 0,
            display: 'block',
            opacity: disableCollapse ? 0.5 : 1,
            pointerEvents: disableCollapse ? 'none' : 'auto',
          }}
          aria-disabled={disableCollapse}
        >
          {!isNBIJourney && <ExpandMoreIcon sx={{ color: theme.palette.secondary.errorCTA }} />}
        </ExpandMore>
      </Grid>
    </Grid>
  );
};

export default EirKeepLandlineCollapseTop;
